// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__hZNMF","iconCard":"DashboardCard_iconCard__AAe7H"};